<template>
    <div>
        <b-modal id="modal-to-items" @hide="fetch_init" scrollable title="TRANSFER ORDER" size="xl" hide-footer style="min-height: 700px;">
           <TransferOrderModal
                v-on:done-items-co="close_to_modal"
                style="min-height: 700px;"
                :viewdata="{
                    id: transfer_order_id,
                    products: products,
                    delivery_date: selected_delivery_date,
                    schedule_date: selected_schedule_date,
                    status: selected_status
                }"
            />
        </b-modal>

        <b-alert :show="show==true">
            <b-button size="sm" variant="success" @click="add_new_to" v-if="!['housetruck', 'deliverytruck'].includes(this.packet.userDetails.userrole)">ADD NEW</b-button>
            <b-button size="sm" variant="primary" @click="fetch_init">
                <span v-if="!first_load">LOAD ORDERS</span>
                <span v-else>RELOAD</span>
            </b-button>
        </b-alert>

        <div v-if="first_load && items.length > 0">
          <!-- Mobile toggle button -->
          <div v-if="isMobile" class="d-flex justify-content-between align-items-center mb-2">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="filtersVisible = !filtersVisible"
            >
              <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
              {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
            </b-button>
          </div>

          <!-- Filters card -->
          <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
            <b-card style="background: #f2f2f2; margin-bottom: 10px;">
              <b-card-text>
                <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                  <div style="width: 250px;"v-if="['admin', 'officemanager', 'warehouseuser',
                    'warehousemanager'].includes(packet.userDetails.userrole)">
                    <div>ORDERING LOCATION</div>
                    <b-form-select
                      :options="filterLocationOptions"
                      v-model="selectedLocation"
                    ></b-form-select>
                  </div>

                  <div style="width: 250px;"v-if="['admin', 'officemanager', 'warehouseuser',
                    'warehousemanager'].includes(packet.userDetails.userrole)">
                    <div>SELLING LOCATION</div>
                    <b-form-select
                      :options="enhancedFilterSellingLocationOptions"
                      v-model="selectedSellingLocation"
                    ></b-form-select>
                  </div>

                  <div style="width: 250px;">
                    <div>STATUS</div>
                    <b-form-select
                      :options="filterStatusOptions"
                      v-model="selectedStatus"
                    ></b-form-select>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </b-collapse>
        </div>
        <div v-if="items_being_loaded == true">
            <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <div v-if="items_being_loaded == false">
                <div v-if="items.length == 0">
                    <div v-if="!first_load">
                    </div>
                    <div v-else>
                        <b-alert show variant="warning">NO TRANSFER ORDERS.</b-alert>
                    </div>
                </div>

                <div v-else>
                    <div v-if="(selectedLocation !== null || selectedSellingLocation !== null || selectedStatus !== null) && displayItems.length === 0">
                        <b-alert show variant="info">No orders match the selected filters.</b-alert>
                    </div>
                    <div class="diver">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <td class="srr" style="width: 120px; background-color: lightgoldenrodyellow;" @click="sortby('id')">ORDER #</td>
                                <td class="srr" style="width: 160px;  background-color: lightgoldenrodyellow;"  @click="sortby('created_by')">ORDERING USER</td>
                                <td class="srr" style="width: 200px;  background-color: lightgoldenrodyellow;"  @click="sortby('ordering_location')">ORDERING LOCATION</td>
                                <td class="srr" style="width: 150px; background-color: lightgoldenrodyellow;" @click="sortby('ts')">ORDERING DATE</td>
                                <td class="srr" style="width: 200px;  background-color: lightgoldenrodyellow;"  @click="sortby('selling_locations')">SELLING LOCATION</td>
                                <td class="srr" style="width: 150px;  background-color: lightgoldenrodyellow;"  @click="sortby('status')">STATUS</td>
                                <td class="srr" style="width: 160px;  background-color: lightgoldenrodyellow;"  @click="sortby('schedule_date')">SCHEDULE DATE</td>
                                <td class="srr" style="width: 160px;  background-color: lightgoldenrodyellow;"  @click="sortby('delivery_date')">REQUEST DATE</td>
                                <td class="srr" style="width: 150px;  background-color: lightblue;"  @click="sortby('received_date')">RECEIVING DATES</td>
                                <td class="srr" style="width: 150px;  background-color: lightblue;"  @click="sortby('SKU')">SKU</td>
                                <td class="srr" style="width: 180px;  background-color: lightblue;"  @click="sortby('product')">ITEM DESCRIPTION </td>
                                <td class="srr" style="width: 100px;  background-color: lightblue;"  @click="sortby('')">ITEMS ORDRD</td>
                                 <td class="srr" style="width: 100px;  background-color: lightblue;"  @click="sortby('')">ITEMS SCH</td>
                                  <td class="srr" style="width: 100px;  background-color: lightblue;"  @click="sortby('')">ITEMS SHIPPED</td>

                                <td class="srr" style="width: 100px;  background-color: lightblue;"  @click="sortby('')">ITEMS RCVD</td>
                                <td class="srr" style="width: 100px;  background-color: lightblue;"  @click="sortby('')">ITEMS REMAIN</td>
                                <td class="srr" style="width: 150px;  background-color: lightblue;"  @click="sortby('')">CUBES</td>
                                <td class="srr" style="width: 200px;"  @click="sortby('truck', packet.trucksdict)">TRUCK</td>
                                <td class="srr" style="width: 150px;  background-color: lightpink;"  @click="sortby('amount')" v-if="packet.userDetails.userrole === 'admin'">TOTAL</td>
                                <td class="srr" style="width: 150px;  background-color: lightpink;"  @click="sortby('paid')" v-if="packet.userDetails.userrole === 'admin'">PAID</td>
                                <td class="srr" style="width: 150px;  background-color: lightpink;"  @click="sortby('balance')" v-if="packet.userDetails.userrole === 'admin'">BALANCE</td>
                                <td @click="sortby('approved')" class="srr" style="width: 200px;  background-color: white;">ACTIONS</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in displayItems" v-bind:key="idx" :style="{background: ((item.approved) ? 'lightyellow': 'white')}">
                               <td class="srrv">
    <div style="display: flex; flex-direction: column; align-items: center;">
        <!-- Bootstrap badge style comment tag -->
        <b-badge v-if="item.comments && item.comments.trim() !== ''" 
                 variant="warning" 
                 class="mb-1 p-2" 
                 :title="item.comments"
                 style="font-size: 10px; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ item.comments }}
        </b-badge>
        <!-- Order number -->
        <div>{{ getPrefixedOrderId(item) }}</div>
    </div>
</td>
                                <td class="srrv">{{item.created_by}}</td>
                                <td class="srrv">
                                    <b-form-select :options="locations" v-model="item.ordering_location" style="font-size: 14px;"
                                      :disabled="!!([3,4,5,6].includes(item.original_status) || item.id || isItemDisable2(item))">
                                    </b-form-select>
                                </td>
                                <td class="srrv">
                                        {{ formatOrderingDate(item.ts) }}
                                    </td>
                                <td class="srrv">
                                    <b-form-select
                                    :options="getSellingLocationOptions(item)"
                                    v-model="item.selling_location"
                                    style="font-size: 14px;"
                                     :disabled="!!([3,4,5,6].includes(item.original_status) || isItemDisable2(item))"
                                    ></b-form-select>
                                </td>
                                <td class="srrv">
                                    <b-form-select
                                        :options="getStatusOptions(item)"
                                        style="font-size: 14px;"
                                        v-model="item.status"
                                          :disabled="!!(shouldDisableStatusChange(item) || isItemDisable2(item))"
                                    ></b-form-select>
                                </td>
                               <td class="srrv">
                                        <date-picker
                                            v-model="item.delivery_date"
                                            format="MM-DD-YYYY"
                                            valueType="format"
                                            disabled
                                            style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;"
                                        ></date-picker>
                                    </td>
                                    <td class="srrv">
                                        <date-picker
                                            v-model="item.schedule_date"
                                            format="MM-DD-YYYY"
                                            valueType="format"
                                            :disabled="[3,5,6].includes(item.original_status) || !hasOrderedItems(item)"
                                            style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;"
                                        ></date-picker>
                                    </td>
                                <td class="srrv">
                                    <div v-if="item.showReceivingDates">
                                        <button v-if="getReceivingDates(item).length > 0" @click="item.showReceivingDates = false">HIDE</button>
                                        <div v-for="(date, idx) in getReceivingDates(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ date }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showReceivingDates = true" :disabled="getReceivingDates(item).length === 0">
                                            SHOW {{ getReceivingDates(item).length }} DATES
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">
                                    <div v-if="item.showSKUs">
                                        <button v-if="getSKUs(item).length > 0" @click="item.showSKUs = false">HIDE</button>
                                        <div v-for="(sku, idx) in getSKUs(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ sku }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showSKUs = true" :disabled="getSKUs(item).length === 0">
                                            SHOW {{ getSKUs(item).length }} SKUs
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">
                                    <div v-if="item.showProducts">
                                        <button v-if="getProductNames(item).length > 0" @click="item.showProducts = false">HIDE</button>
                                        <div v-for="(product, idx) in getProductNames(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ product }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showProducts = true" :disabled="getProductNames(item).length === 0">
                                            SHOW {{ getProductNames(item).length }} PRODUCTS
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">
                                    {{ getTotalOrdered(item) }}
                                </td>
                                 <td class="srrv">
                                    {{ getTotalScheduled(item) }}
                                </td>
                                <td class="srrv">
                                    {{ getTotalShipped(item) }}
                                </td>
                                <td class="srrv">
                                    {{ getTotalReceived(item) }}
                                </td>
                                <td class="srrv">
                                    {{ getTotalRemaining(item) }}
                                </td>
                                <td class="srrv">
                                    {{ getTotalCubes(item) }}
                                </td>
                                 <td class="srrv">
                                    <b-form-select size="sm" :options="trucks" v-model="item.truck"
                                    :disabled="!!([3,4,5,6].includes(item.original_status) || isItemDisable2(item))"
                                     v-on:change="save_transfer_order(item)"></b-form-select>
                                </td>
                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    {{ (parseFloat(item.amount) || 0.0).toFixed(2) }}
                                </td>
                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    <span v-if="item.paid > 0" style="background: bisque; padding: 5px;">
                                        {{ (parseFloat(item.paid) || 0.0).toFixed(2) }}
                                    </span>
                                    <span v-else>
                                        {{ (parseFloat(item.paid) || 0.0).toFixed(2) }}
                                    </span>
                                </td>
                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    <span v-if="item.balance > 0" style="background: lightyellow; padding: 5px;">
                                        {{ (parseFloat(item.balance) || 0.0).toFixed(2) }}
                                    </span>
                                    <span v-else>
                                        {{ (parseFloat(item.balance) || 0.0).toFixed(2) }}
                                    </span>
                                </td>
                                 <td class="srrv">
                                    <span v-if="item.loading">
                                        <loading
                                            :active="true"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>
                                    </span>
                                    <span v-else>
                                        <b-button
                                            size="sm"
                                            variant="outline-primary"
                                            @click="view_transfer_order(item)"
                                            v-b-tooltip.hover title="VIEW"
                                            v-if="(item.id) &&
                                                (
                                                    (item.ordering_location == packet.userDetails.properties.location_id && packet.userDetails.userrole == 'locationadmin' ) || (['admin', 'officemanager'].includes(packet.userDetails.userrole))
                                                )"
                                        >
                                            <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button size="sm" variant="outline-success" @click="save_transfer_order(item)" v-b-tooltip.hover title="SAVE" :disabled="shouldDisableRow(item)">
                                            <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            @click="delete_transfer_order(item)"
                                            variant="outline-danger"
                                            :disabled="!canDeleteOrder(item)"
                                            v-if="item.username == item.created_by || ['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover :title="getDeleteButtonTooltip(item)"
                                        >
                                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            @click="approve_transfer_order(item)"
                                            :disabled = "!hasValidDeliveryDate(item)"
                                            :variant="((item.approved) ? 'success' : 'outline-secondary')"
                                            v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover
                                            :title="((item.approved) ? 'APPROVED' : 'APPROVE')"
                                        >
                                            <b-icon icon="shield-check" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <div v-else>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { BIconFunnelFill, BIconEye, BIconEyeFill } from 'bootstrap-vue'

    import TransferOrderModal from '@/components/TransferOrders/TransferOrderModal';

    export default {
        name: "ListTransferOrders",
        props: [],
        components: {flatPickr, Loading, DatePicker, TransferOrderModal, BIconFunnelFill, BIconEye, BIconEyeFill},
        data: function(){
            return {
                packet: {},
                show: true,
                first_load: null,
                items: [], // Default items (filtered to exclude RECEIVED, COMPLETED, and DISCREPANCY)
                allItems: [], // All items including RECEIVED, COMPLETED, and DISCREPANCY
                items_being_loaded: null,
                transfer_order_id: null,
                products: [],
                locations: [],
                trucks: [],
                selectedLocation: null,
                selected_delivery_date: null,
                selected_schedule_date: null,
                selected_status: null,
                selectedStatus: null,
                filteredItems: [],
                filterLocationOptions: [
                    { value: null, text: 'All Locations' },
                ],
                filterStatusOptions: [
                    { value: null, text: 'All' },
                ],
                selectedSellingLocation: null,
                filterSellingLocationOptions: [
                    { value: null, text: 'All Selling Locations' },
                ],
                meccaWholesaleValue: 0,
                sort_asc: true,
                 locationPrefixes: {
                    'ALLENTOWN STORE': 'AT',
                    'MECCA SHIPPING': 'MS',
                    '101 WH': 'WH-VEN',
                    'FOLCROFT': 'WH-FOL',
                    '9TH ST ': 'WH-9',
                    'VENANGO STORE': '101',
                    'READING STORE': 'RD',
                    'LANCASTER AVE STORE': '56-ST',
                    'EWING STORE': 'EW',
                    'DELMAR STORE': 'FLC',
                    'LANSDOWNE STORE': 'BLT',
                    'UPPER DARBY STORE': 'UD',
                    'HUNTING PARK STORE': 'HP',
                },
                filtersVisible: false,
                isMobile: false,
            }
        },

        watch: {
            items: {
                deep: true,
                handler(newItems) {
                    newItems.forEach(item => {
                        if (item.delivery_date && item.status === 1) {
                            item.status = 2;
                        }
                    });
                }
            },
            selectedLocation() {
                this.applyFilters();
            },
            selectedSellingLocation(newVal, oldVal) {
                if (newVal === this.meccaWholesaleValue) {
                    this.applyFilters();
                }
            },
            selectedStatus() {
                this.applyFilters();
            },
        },
        methods: {
            getCommentTagClass(item) {
    if (item.comments.toLowerCase().includes('re-order') || 
        item.comments.toLowerCase().includes('reorder')) {
        return 'comment-tag-reorder';
    }
    if (item.comments.toLowerCase().includes('urgent')) {
        return 'comment-tag-urgent';
    }
    return 'comment-tag-default';
},
            hasValidDeliveryDate(item) {
                if (!item.delivery_date) return false;
                if (item.delivery_date.trim && item.delivery_date.trim() === '') return false;
                if (item.delivery_date === null || item.delivery_date === undefined) return false;
                if (item.delivery_date === 'Invalid date') return false;
                return true;
            },
            hasOrderedItems(item) {
                if (!item.items || !Array.isArray(item.items)) return false;
                return item.items.some(i => (parseInt(i.quantity) || 0) > 0);
            },
            getTotalOrdered(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity) || 0), 0);
            },
             getTotalScheduled(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity_scheduled) || 0), 0);
            },
            getTotalShipped(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity_shipped) || 0), 0);
            },
            getTotalReceived(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity_received) || 0), 0);
            },
            getTotalRemaining(item) {
                return this.getTotalOrdered(item) - this.getTotalReceived(item);
            },
            getTotalCubes(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => {
                    const cubes = parseFloat(i.cubes) || 0;
                    const quantity = parseInt(i.quantity) || 0;
                    return sum + (cubes * quantity);
                }, 0).toFixed(2);
            },
            formatOrderingDate: function(timestamp) {
                if (!timestamp) return 'N/A';
                return moment(timestamp).format('MM-DD-YYYY');
            },
            isItemDisabled(item) {
                return item.original_status === 6;
            },
            isItemDisable2(item) {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return true;
                }
            },
            calculateOverallStatus(items) {
                if (!items || items.length === 0) return 1;
                const statusCounts = {
                    ordered: 0,
                    scheduled: 0,
                    received: 0,
                    partial: 0,
                    completed: 0,
                    archived: 0
                };
                items.forEach(item => {
                    switch(item.status) {
                        case 1: statusCounts.ordered++; break;
                        case 2: statusCounts.scheduled++; break;
                        case 3: statusCounts.received++; break;
                        case 4: statusCounts.partial++; break;
                        case 5: statusCounts.completed++; break;
                        case 6: statusCounts.archived++; break;
                    }
                });
                if (statusCounts.partial > 0) return 4;
                if (statusCounts.scheduled > 0) return 2;
                if (statusCounts.ordered > 0) return 1;
                if (statusCounts.received === items.length) return 3;
                if (statusCounts.received > 0) return 4;
                return 1;
            },
            canDeleteOrder(item) {
                return item.status === 6;
            },
            getDeleteButtonTooltip(item) {
                return this.canDeleteOrder(item)
                    ? "DELETE"
                    : "Only archived orders can be deleted";
            },
            shouldDisableStatusChange(item) {
                if ([3, 4].includes(item.original_status)) {
                    return true;
                }
                if (!this.isAdmin() && [5, 6].includes(item.original_status)) {
                    return true;
                }
                return false;
            },
            getLocationNameById(locationId) {
                const location = this.locations.find(loc => loc.value === parseInt(locationId));
                return location ? location.text : null;
            },
            getPrefixedOrderId(item) {
                if (!item.id) return 'NEW ORDER';
                const locationName = this.getLocationNameById(item.ordering_location);
                const prefix = locationName ? this.locationPrefixes[locationName] : 'STO';
                return `${prefix}-${item.id}`;
            },
            getReceivingDates(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items
                    .filter(i => i.received_date && i.received_date !== 'null')
                    .map(i => i.received_date)
                )];
            },
            getSKUs(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items.map(i => i.product_sku))];
            },
            getProductNames(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items.map(i => i.product_name))];
            },
            getStatusOptions(item) {
                return this.allStatuses.map(status => {
                    let disabled = false;
                    if ([3, 4].includes(item.original_status)) {
                        disabled = true;
                    }
                    if (['RECEIVED', 'PARTIAL'].includes(status.text)) {
                        disabled = true;
                    }
                    const currentStatus = this.allStatuses.find(s => s.value === item.status);
                    const currentStatusText = currentStatus ? currentStatus.text : null;
                    if (['RECEIVED', 'PARTIAL'].includes(currentStatusText) &&
                        status.text === 'ARCHIVED') {
                        disabled = true;
                    }
                    if ([3, 4].includes(item.original_status) &&
                        ['ORDERED', 'SCHEDULED'].includes(status.text)) {
                        disabled = true;
                    }
                    return { ...status, disabled };
                });
            },
            applyFilters() {
                if (!Array.isArray(this.allItems)) {
                    this.filteredItems = [];
                    return;
                }
                this.filteredItems = this.allItems.filter(item => {
                    if (!item) return false;
                    const locationMatch = this.selectedLocation === null ||
                                        item.ordering_location === this.selectedLocation;
                    let sellingLocationMatch;
                    if (this.selectedSellingLocation === this.meccaWholesaleValue) {
                        sellingLocationMatch = parseInt(item.selling_location) === 0;
                    } else {
                        sellingLocationMatch = this.selectedSellingLocation === null ||
                                            item.selling_location === this.selectedSellingLocation;
                    }
                    const statusMatch = this.selectedStatus === null ||
                                    item.status === this.selectedStatus;
                    return locationMatch && sellingLocationMatch && statusMatch;
                });
            },
            applyDefaultFilter() {
                if (!Array.isArray(this.allItems)) {
                    this.items = [];
                    return;
                }
                // Filter out RECEIVED (3), COMPLETED (5), and DISCREPANCY (7)
                this.items = this.allItems.filter(item => {
                    return item.status !== 3 && item.status !== 5;
                });
            },
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            shouldDisableRow(item) {
                if (!item) return true;
                if (!this.isAdmin() && [3,4,5].includes(item.status)) {
                    return true;
                }
                return false;
            },
            approve_transfer_order: function(item){
                if (item.approved){
                    return
                }
                let path = "/api/sales/approve_transfer_order/"
                let data = {"id": item.id, "approved": true}
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR APPROVING TRANSFER ORDER.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SUCCESS APPROVING TRANSFER ORDER.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (response.data.result.length > 0){
                            let approved = response.data.result[0]["approved"];
                            item.approved = approved;
                        }
                    }
                    item.loading = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH APPROVING TRANSFER ORDER. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            save_transfer_order: function(item){
                let data = item;
                let path = "/api/sales/record_transfer_order/"
                if (item.id){
                    path = "/api/sales/update_transfer_order/"
                }
                if ([3, 4].includes(item.original_status) &&
                [1, 2].includes(item.status)) {
                    this.$bvToast.toast(
                        "Cannot revert order status once received, partial, or discrepancy",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    item.status = item.original_status;
                    return;
                }
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR SAVING TRANSFER ORDER.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result.length > 0){
                            let id = response.data.result[0].id;
                            item.id = id;
                        }
                    }
                    item.loading = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH SAVING TRANSFER ORDER. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_current_time: function(){
                return moment().format("MM-DD-YYYY hh:mm:ss")
            },
            fetch_init: function(){
                let data = {}
                let path = "/api/sales/get_transfer_orders/"
                if (!['admin', 'officemanager', 'housetruck', 'deliverytruck'].includes(this.packet.userDetails.userrole) && this.packet.userDetails.properties.location_id){
                    data.location_id = parseInt(this.packet.userDetails.properties.location_id);
                    data.user_role = this.packet.userDetails.userrole;
                }
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING TRANSFER ORDERS.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result) {
                            let res = response.data.result;
                            // Store all items
                            that.allItems = res.map(item => {
                                return {
                                    ...item,
                                    original_status: item.status,
                                    showReceivingDates: false,
                                    showSKUs: false,
                                    showProducts: false
                                };
                            });
                            
                            // Apply default filter (hide RECEIVED, COMPLETED, and DISCREPANCY by default)
                            that.applyDefaultFilter();
                        };
                        that.first_load = true;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH TRANSFER ORDERS. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            add_new_to: function(){
                if (this.items.filter(function(d){return !(d.id) }).length > 0){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE EXISTING NEW ORDER FIRST."}
                    );
                    return
                }
                let defaultOrderingLocation = null;
                if (!['admin', 'officemanager'].includes(this.packet.userDetails.userrole)) {
                    const userLocationId = this.packet.userDetails.properties.location_id;
                    if (userLocationId) {
                        defaultOrderingLocation = parseInt(userLocationId);
                    }
                }
                if (['admin', 'officemanager'].includes(this.packet.userDetails.userrole) && this.locations.length > 0) {
                    defaultOrderingLocation = this.locations[0].value;
                }
               let item = {
                id: null,
                created_by: this.packet.userDetails.username,
                ordering_location: defaultOrderingLocation,
                selling_location: null,
                status: 1,
                original_status: null,
                ts: new Date().toISOString(),
                comments: null,
                delivery_date: null,
                schedule_date: null,
                is_new: true,
            }
                this.items.splice(0, 0, item);
                this.allItems.splice(0, 0, item);
            },
          delete_transfer_order: function(item){
    if (!item.id){
        this.items = this.items.filter(function(d){return d.id});
        this.allItems = this.allItems.filter(function(d){return d.id});
        return;
    }
    
    let path = "/api/sales/delete_transfer_order/"
    let data = {id: item.id}
    let that = this;
    
    let deleteOrder = function(forceDelete = false) {
        let deleteData = {id: item.id};
        if (forceDelete) {
            deleteData.force_delete = true; // Add flag to indicate force delete
        }
        
        let s = function(response) {
            if (response.data.error){
                that.$bvToast.toast(
                    "ERROR DELETING TRANSFER ORDER",
                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                );
            }
            else if (response.data.has_children) {
                // Show confirmation dialog for child orders
                let childCount = response.data.child_count;
                that.$bvModal.msgBoxConfirm(
                    `This order has ${childCount} reorder(s) associated with it. Deleting this order will also delete all associated reorders. Are you sure you want to continue?`,
                    {
                        title: 'Confirm Deletion',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'YES, DELETE',
                        cancelTitle: 'CANCEL',
                        footerClass: 'p-2',
                        centered: true
                    }
                ).then(value => {
                    if (value) {
                        // User confirmed, delete with force flag
                        deleteOrder(true);
                    }
                });
            }
            else {
                that.$bvToast.toast(
                    "DELETED TRANSFER ORDER",
                    {title: "Success", autoHideDelay: 1500, variant:"success"}
                );
                that.fetch_init();
            }
            that.items_being_loaded = false;
        }
        
        let f = function(error) {
            that.$bvToast.toast(
                "ERROR OCCURRED.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
            that.items_being_loaded = false;
        }
        
        that.items_being_loaded = true;
        Requestor.postSyncP(path, deleteData, that, s, f);
    }
    
    // Start the deletion process
    deleteOrder(false);
},
            view_transfer_order: function(item){
                console.log('Opening transfer order:', {
                    id: item.id,
                    delivery_date: item.delivery_date,
                    schedule_date: item.schedule_date,
                    status: item.status
                });
                this.selected_delivery_date = item.delivery_date;
                this.selected_schedule_date = item.schedule_date;
                this.selected_status = item.status;
                this.show_to_modal(item);
            },
            show_to_modal: function(item){
                if (!item){
                    this.transfer_order_id = null;
                    this.selected_delivery_date = null;
                    this.selected_schedule_date = null;
                    this.selected_status = null;
                }
                else {
                    this.transfer_order_id = item.id;
                    this.selected_delivery_date = item.delivery_date;
                    this.selected_schedule_date = item.schedule_date;
                    this.selected_status = item.status;
                }
                this.$bvModal.show("modal-to-items");
            },
            close_to_modal: function(){
                this.$bvModal.hide("modal-to-items");
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper);
                    this.allItems = Requestor.sort(this.allItems,key,mapper);
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper);
                    this.allItems = Requestor.sort_reverse(this.allItems,key,mapper);
                }
                this.sort_asc = !this.sort_asc;
            },
            getSellingLocationOptions(item) {
                const orderingLoc = this.locations.find(loc => loc.value === item.ordering_location);
                const isMainWarehouse = orderingLoc && orderingLoc.is_main_warehouse;
                return this.enhancedSellingLocations
                    .filter(loc => {
                        if (loc.value === item.ordering_location) {
                            return false;
                        }
                        if (loc.value === 46) {
                            return false;
                        }
                        return true;
                    })
                    .map(loc => {
                        let disabled = false;
                        if (isMainWarehouse) {
                            const isMeccaForAdmin =
                                loc.value === this.meccaWholesaleValue &&
                                this.packet.userDetails.userrole === "admin";
                            if (isMeccaForAdmin) {
                                disabled = true;
                            }
                            if (item.selling_location === this.meccaWholesaleValue) {
                                this.$set(item, "selling_location", null);
                            }
                        } else {
                            if (loc.value === this.meccaWholesaleValue) {
                                if (!item.is_new || item.selling_location === this.meccaWholesaleValue) {
                                    null;
                                } else if (item.selling_location !== this.meccaWholesaleValue && item.ordering_location) {
                                    this.$set(item, "selling_location", this.meccaWholesaleValue);
                                }
                            }
                        }
                        return { ...loc, disabled };
                    });
            },
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
        },
        mounted() {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            displayItems() {
                // When filters are active, show filtered items
                if (this.selectedLocation !== null ||
                    this.selectedSellingLocation !== null ||
                    this.selectedStatus !== null) {
                    
                    if (this.filteredItems.length === 0) {
                        return [];
                    }
                    
                    // If a specific status is selected, show it regardless
                    if (this.selectedStatus !== null) {
                        return this.filteredItems;
                    }
                    
                    // Otherwise filter out RECEIVED, COMPLETED, and DISCREPANCY
                    return this.filteredItems.filter(item => 
                        item.status !== 3 && item.status !== 5
                    );
                }
                
                // Otherwise show the default items (already filtered in applyDefaultFilter)
                return this.items;
            },
            enhancedSellingLocations() {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return [{ value: this.meccaWholesaleValue, text: "Mecca Wholesale" }];
                } else {
                    let sellingLocs = [...this.selling_locations];
                    const meccaWholesaleOption = {
                        value: this.meccaWholesaleValue,
                        text: "Mecca Wholesale"
                    };
                    return [meccaWholesaleOption, ...sellingLocs];
                }
            },
            displaySellingLocation() {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return this.meccaWholesaleValue;
                } else {
                    return this.selectedSellingLocation;
                }
            },
            enhancedFilterSellingLocationOptions() {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return [
                        { value: null, text: 'All Selling Locations' },
                        { value: this.meccaWholesaleValue, text: 'Mecca Wholesale' }
                    ];
                } else {
                    let filterOptions = [...this.filterSellingLocationOptions];
                    return [
                        filterOptions[0],
                        { value: this.meccaWholesaleValue, text: 'Mecca Wholesale' },
                        ...filterOptions.slice(1)
                    ];
                }
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            console.log(this.packet.userDetails);

            // Filter selling locations based on user role
            if (this.packet.userDetails.userrole !== 'admin') {
                this.selling_locations = this.packet.locations.filter(function(d) {
                    return [40, 41, 42].includes(d.value);
                });
            } else {
                this.selling_locations = this.packet.locations.filter(function(d) {
                    return d.text != 'All';
                });
            }

            // Status options - REMOVE DISCREPANCY from the list
            this.allStatuses = [
                {value: 1, text: "ORDERED"},
                {value: 2, text: "SCHEDULED"},
                {value: 4, text: "PARTIAL"},
                {value: 3, text: "RECEIVED"},
                {value: 5, text: "COMPLETED"},
                {value: 6, text: "ARCHIVED"},
           
            ];

            this.filterStatusOptions = [
                { value: null, text: 'All' },
                ...this.allStatuses
            ];

            this.statuses = this.allStatuses.map(status => {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return {
                        ...status,
                        disabled: ['SCHEDULED','COMPLETED', 'ARCHIVED'].includes(status.text)
                    };
                }
                return status;
            });

            // Get all locations (excluding 'All') first
            let allLocations = this.packet.locations.filter(function(d) { return d.text != 'All' });

            // Initialize filter location options
            this.filterLocationOptions = [
                { value: null, text: 'All Locations' },
                ...allLocations.map(loc => ({
                    value: loc.value,
                    text: loc.text
                }))
            ];

            this.filterSellingLocationOptions = [
                { value: null, text: 'All Shipping Locations' },
                ...this.selling_locations.map(loc => ({
                    value: loc.value,
                    text: loc.text
                }))
            ];

            // Filter locations based on user role
            if (!['admin', 'officemanager', 'housetruck', 'deliverytruck'].includes(this.packet.userDetails.userrole)) {
                const userLocationId = this.packet.userDetails.properties.location_id;
                this.locations = allLocations.filter(function(d) {
                    return d.value == userLocationId;
                });
            } else {
                if (['admin'].includes(this.packet.userDetails.userrole)) {
                  this.locations = allLocations.filter(item => ![46, 47].includes(item.value));
                } else {
                  this.locations = allLocations.filter(item => ![46].includes(item.value));
                }
            }

            this.trucks = this.packet.housetrucks.filter(function(d) { return d.text != "" });
        },
    }
</script>

<style scoped>
.comment-tag-default {
    background-color: #ffc107;
    color: #000;
}

.comment-tag-reorder {
    background-color: #17a2b8;  /* Info blue */
    color: white;
}

.comment-tag-urgent {
    background-color: #dc3545;  /* Danger red */
    color: white;
}

.comment-tag {
    font-size: 10px;
    padding: 2px 8px;
    border-radius: 12px;
    margin-bottom: 4px;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    border: 1px solid rgba(0,0,0,0.1);
}
.btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.diver {
    overflow: auto;
    width: 100%;
    height: 600px;
}

td,
th {
    border: 1px solid;
    width: 300px;
}

th {
    background-color: white;
}

table {
    table-layout: fixed;
    width: 100%;
}

td:first-child,
th:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
    background-color: white;
}

td:last-child,
th:last-child {
    position: sticky;
    right: 0;
    z-index: 1;
    background-color: white;
    width: 150px;
}

thead tr th {
    position: sticky;
    top: 0;
}

th:first-child,
th:last-child {
    z-index: 2;
    background-color: white;
}

.table-container {
    width: 100%;
    overflow-x: auto;
    max-height: 80vh;
}

table tr td:first-child {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 1;
}

table tr td:last-child {
    position: sticky;
    right: 0;
    background-color: white;
    z-index: 1;
}

table thead tr td:first-child {
    position: sticky;
    left: 0;
    background-color: lightgray;
    z-index: 2;
}

table thead tr td:last-child {
    position: sticky;
    right: 0;
    background-color: lightgray;
    z-index: 2;
}

.srr {
    font-size: 14px;
    text-align: center;
    background: #ffeaa7;
    border: 1px solid #010101;
    font-weight: bold;
}

.srrv {
    font-size: 14px;
    text-align: center;
    border: 1px solid #010101;
    padding: 5px;
}

.box {
    padding: 3px;
    text-align: center;
    margin: 5px;
    background: #c8e6c9;
    color: black;
    border: 1px solid black;
}

@media (max-width: 768px) {
    td:first-child,
    th:first-child,
    td:last-child,
    th:last-child,
    thead tr th {
        position: static !important;
        left: auto !important;
        right: auto !important;
        top: auto !important;
        z-index: auto !important;
    }

    .diver {
        height: auto;
        overflow-x: auto;
        overflow-y: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/ListTransferOrders.vue